module.exports = __webpack_public_path__ + "static/media/builder_logic.911c539d.gif";